const AWARDING_RULE = 'awardingRule';
const BREAK_RULE = 'breakRule';

export const RuleSetType = Object.freeze({
    [AWARDING_RULE]: 0,
    [BREAK_RULE]: 1,
});

export const RuleSetTypeNames = Object.freeze({
    0: AWARDING_RULE,
    1: BREAK_RULE,
});
